/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InstallmentAmount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputCurrency from 'DesignSystem/TysiaInput/TysiaInputCurrency/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function InstallmentAmount({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/DefaultPayorSchedule/InstallmentAmount",
  onChange
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let settingsDataDefaultPayorScheduleTypeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.type',
})
let constantData = 'INSTALLMENT_AMOUNT'
let aggregateData = fromAggregate.equals(settingsDataDefaultPayorScheduleTypeValueData, constantData)
let onClick = fromHelpers.useOnClickInstallmentAmount({
  children,
  viewPath,
  onChange
  
})
let settingsDataDefaultPayorScheduleInstallmentAmountValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.installment_amount',
})
let settingsDataDefaultPayorScheduleInstallmentAmountChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.installment_amount',
})
let settingsDataDefaultPayorScheduleTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.type',
})
let constantData1 = 'INSTALLMENT_AMOUNT'
let aggregateData1 = fromAggregate.equals(settingsDataDefaultPayorScheduleTypeValueData1, constantData1)
  return (<React.Fragment
>
<div
  data-testid="InstallmentAmount.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1NANRj': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 onClick={onClick}
 data="settings.data.default_payor_schedule.type"
 data="'INSTALLMENT_AMOUNT'"
 aggregate="/Data/aggregate equals"
 isSelected={aggregateData}
 text="Default installment amount"
 width={220}
/>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="settings.data.default_payor_schedule.installment_amount"
 value={settingsDataDefaultPayorScheduleInstallmentAmountValueData}
 onChange={settingsDataDefaultPayorScheduleInstallmentAmountChangeData}
 data="settings.data.default_payor_schedule.type"
 data="'INSTALLMENT_AMOUNT'"
 aggregate="/Data/aggregate equals"
 disabled={!aggregateData1}
 marginTop={0}
 maxWidth={150}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputCurrency
{...childProps}
  viewPath={`${viewPath}/TysiaInputCurrency`}
 placeholder="$0.00"
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
</div>
{children}
</React.Fragment>)
}